import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EosListComponent } from './eos-list.component';


const routes: Routes = [
  { path: 'eos/:market', component: EosListComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EosListRoutingModule {
  static components = [ EosListComponent ];
}
